import Accordion from 'react-bootstrap/Accordion';
import styled from 'styled-components';
function InfoNiveles({ requisitos }) {
    return (
        <Acordeon>
            <Accordion.Item eventKey="0">
                <Accordion.Header>Información Niveles</Accordion.Header>
                <Accordion.Body>
                    <ul>
                        {requisitos.map((requisito) => (

                            <>
                                <li key={requisito.Id} value={requisito.Id}>
                                    <h6>Nivel: {requisito.Id}</h6>
                                    {requisito.descripcion}
                                </li>
                                <br />

                            </>


                        ))}
                    </ul>
                </Accordion.Body>
            </Accordion.Item>
        </Acordeon>


    );
}

const Acordeon = styled(Accordion)`
    margin: 5% 0% 5% 0%;
    .accordion-button:focus {
    border-color: rgb(238, 128, 93) !important;
    box-shadow: none !important;
    
}

.accordion-button:not(.collapsed) {
    color: white !important;
    background-color: rgb(238, 128, 93) !important;
    box-shadow: rgb(238, 128, 93) !important;
}
`

export default InfoNiveles;
